import { inject, Injector } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { firstValueFrom } from 'rxjs';
import { UserSelfService } from '../api/user-self.service';

export const authGuard: CanActivateFn = async () => {
  const oidc     = inject(OidcSecurityService);
  const router   = inject(Router);
  // Capture the injector synchronously — after the first `await` the injection
  // context is gone and `inject()` throws NG0203, so we resolve services we need
  // post-await via this injector instead.
  const injector = inject(Injector);

  const result = await firstValueFrom(oidc.checkAuth());
  if (!result.isAuthenticated) return router.createUrlTree(['/login']);

  // Kick off the account check (GET api/users/self) now — while the shell chunk
  // and map are still loading — so the "no account" warning can surface the moment
  // a 403 lands rather than waiting on the heavy shell to construct the service.
  // Only after auth is confirmed, so we don't fire the self probe for a user we're
  // about to bounce to /login.
  injector.get(UserSelfService);
  return true;
};
